import { render, staticRenderFns } from "./SubscriptionNotifier.vue?vue&type=template&id=b73151a4&scoped=true&"
import script from "./SubscriptionNotifier.vue?vue&type=script&lang=js&"
export * from "./SubscriptionNotifier.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionNotifier.vue?vue&type=style&index=0&id=b73151a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73151a4",
  null
  
)

export default component.exports